import React from "react";
import { useApp } from "../context/AppContext";
import { IMAGES } from "../mock";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const copy = {
  nl: {
    kicker: "OVER LÉLUNE",
    title: "Schoonheid met een geweten.",
    p1: "LÉLUNE is geboren in Nederland vanuit een simpel idee: verzorging die werkt, zonder ruis. We combineren biomimetische peptiden met minimalistische, clean formules die de huid en lippen echt voeden.",
    p2: "Elk product wordt met zorg samengesteld, dermatologisch getest en vanuit Nederland verzonden. Vegan, cruelty-free en verpakt in materialen die we met trots tonen.",
    p3: "Van ons Copper Peptide Complex tot onze Color Lip Tints — alles draait om zachte kracht: doeltreffend, elegant en eerlijk.",
    back: "Terug naar home",
  },
  en: {
    kicker: "ABOUT LÉLUNE",
    title: "Beauty with a conscience.",
    p1: "LÉLUNE was born in the Netherlands from a simple idea: care that works, without the noise. We blend biomimetic peptides with minimalist, clean formulas that truly nourish skin and lips.",
    p2: "Every product is carefully formulated, dermatologically tested and shipped from the Netherlands. Vegan, cruelty-free and wrapped in materials we're proud to show.",
    p3: "From our Copper Peptide Complex to our Color Lip Tints — it's all about gentle power: effective, elegant and honest.",
    back: "Back to home",
  },
};

const About = () => {
  const { lang } = useApp();
  const c = copy[lang];
  return (
    <main className="max-w-[1000px] mx-auto px-5 py-20 md:py-28">
      <Link to="/" className="inline-flex items-center gap-2 text-[12px] tracking-label uppercase text-[#B4715C] hover:text-[#9E5F4B]">
        <ArrowLeft className="h-4 w-4" /> {c.back}
      </Link>
      <span className="block mt-10 text-[11px] tracking-label uppercase text-[#B4715C]">{c.kicker}</span>
      <h1 className="mt-4 font-serif text-4xl md:text-6xl text-[#3A2C28] leading-tight">{c.title}</h1>
      <div className="mt-10 grid md:grid-cols-2 gap-12 items-start">
        <div className="space-y-6 text-[15px] leading-relaxed text-[#6E5A52]">
          <p>{c.p1}</p>
          <p>{c.p2}</p>
          <p>{c.p3}</p>
        </div>
        <div className="rounded-3xl overflow-hidden bg-white border border-[#EEDDD3] shadow-xl">
          <img src={IMAGES.serum} alt="LÉLUNE" className="w-full h-[420px] object-contain p-8" />
        </div>
      </div>
    </main>
  );
};

export default About;
